export default function DistributorSelectorComponent(module) {
    angular.module(module)
        .component('distributorSelector', {
            bindings: {
                distributorSelectorPlaceholder: '@',
                customDistributorPrompt: '@',
                namePlaceholder: '@',
                cityPlaceholder: '@',
                statePlaceholder: '@',
                onChange: '&?'
            },
            require: {
                ngModel: '?ngModel'
            },
            template: `
                <select ng-model="vm.distributor" ng-change="vm.updateData()">
                    <option selected value="">Select Distributor Location</option>
                    <option value="custom">{{vm.customDistributorPrompt}}</option>
                    <option ng-value="distributor" ng-repeat="distributor in vm.distributors">{{distributor.name}}</option>
                </select>
                <input type="text" ng-model="vm.model.name" disabled placeholder="{{vm.namePlaceholder}}" ng-disabled="vm.locked" ng-change="vm.inputChanged('name')" />
                <span class="field-validation-error" ng-if="vm.changed.name && !vm.model.name">The name of the distributor is required.</span>
                <input type="text" ng-model="vm.model.city" type="text" disabled placeholder="{{vm.cityPlaceholder}}" ng-disabled="vm.locked" ng-change="vm.inputChanged('city')" />
                <span class="field-validation-error" ng-if="vm.changed.city && !vm.model.city">The city is a required field.</span>
                <select ng-model="vm.model.state" disabled ng-disabled="vm.locked" ng-change="vm.inputChanged('state')">
                    <option disabled selected value="">{{vm.statePlaceholder}}</option>
                    <optgroup label="{{group.name}}" ng-repeat="group in vm.states">
                        <option ng-repeat="option in group.options">{{option}}</option>
                    </optgroup>
                </select>
                <span class="field-validation-error" ng-if="vm.changed.state && !vm.model.state">Please select a state from the dropdown.</span>
            `,
            controller: distributorSelectorController,
            controllerAs: 'vm'
        });
    var id = 1;
    distributorSelectorController.$inject = ['$http', '$timeout', '$element'];
    function distributorSelectorController($http, $timeout, $element) {
        var vm = this;

        vm.$onInit = () => {
            vm._id = id++;
            vm.ngModel.$viewChangeListeners.push(vm.updateViewModel);
            vm.changed = {};
            vm.locked = true;
            $http.get('/api/formextensions/states/', {
                    cache: true
            })
                .then((response) => {
                    vm.states = response.data;
                });
            $timeout(vm.updateViewModel);
        }

        vm.$onChanges = changes => {
            if (changes.options) {
                vm.updateViewModel();
            }
        }

        vm.clear = () => {
            vm.updateViewModel(true);
            vm.updateModel();
        }

        vm.updateData = () => {
            vm.isCustom = vm.distributor === 'custom';
            if (!vm.distributor || vm.isCustom) {
                vm.model = {};
            }
            else {
                vm.model = angular.copy(vm.distributor);
            }
            if (vm.isCustom) {
                vm.changed = {};
                vm.locked = false;
                $timeout(() => {
                    $element[0].querySelector('input').focus();
                });
            }
            else {
                vm.locked = true;
            }
            vm.updateModel();
        }

        vm.updateViewModel = (clear) => {
            if (clear) {
                vm.model = {};
                delete vm.distributor;
            }
            else {
                if (typeof (vm.ngModel.$viewValue) === 'string') {
                    vm.model = vm.ngModel.$viewValue ? JSON.parse(vm.ngModel.$viewValue) : {};
                }
                else {
                    vm.model = angular.copy(vm.ngModel.$viewValue);
                }

                $http.get('/api/formextensions/distributors/', {
                    cache: true
                })
                    .then((response) => {
                        vm.distributors = response.data;
                        if (vm.model) {
                            var name = vm.model.name;
                            if (name) {
                                for (var i = 0; i < vm.distributors.length; i++) {
                                    var distributor = vm.distributors[i];
                                    if (distributor.name === name) {
                                        vm.distributor = distributor;
                                        break;
                                    }
                                }
                                if (!vm.distributor) {
                                    vm.distributor = 'custom';
                                }
                            }
                        }
                    });
            }
        }

        vm.inputChanged = key => {
            if (!vm.locked) {
                if (vm.changed[key]) {
                    vm.updateModel();
                }
                else {
                    vm.changed[key] = true;
                }
            }
        }

        vm.updateModel = () => {
            if (vm.ngModel) {
                if (JSON.stringify(vm.model) === '{}') {
                    vm.ngModel.$setViewValue(undefined);
                }
                else {
                    vm.ngModel.$setViewValue(angular.copy(vm.model));
                }
            }
            if (vm.onChange) {
                vm.onChange({
                    value: angular.copy(vm.model)
                });
            }
        }
    }
}